import { styled } from 'styled-components';

export const StyledAlertResponseFooter = styled.footer`
  display: flex;
  flex-direction: row;
  margin: ${({ theme }) => theme.spacing(2)}px;
`;
